import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import cN from 'classnames';
import BubbleBox from '@components/Common/BubbleBox';
import { RootState } from '@Redux/detail/store';
import { Flag, Info } from '@components/Common/Icons';
import { Link } from 'react-scroll';
import styles from '../style.module.scss';
import { useMediaQuery } from 'react-responsive';
import { LightBox } from '@lion-design/core';

const Place = () => {
    const { GroupInfo } = useSelector((store: RootState) => store.groupReducer);
    const { StationInfoList } = useSelector((store: RootState) => store.stationInfoReducer);

    const [isAssembleOpen, setIsAssembleOpen] = useState<boolean>(false);
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    const bubbleContent = '若出發地與集合地為不同地點，交通方式請參閱產品頁詳細說明！';
    return StationInfoList.length > 0 ? (
        <div className={cN(styles['group-trip-info'], styles.place, 'group_trip_info', 'place')}>
            <div className={cN(styles['title-wrap'], styles['flex'], styles['mb-10'])}>
                <span className={cN(styles['title'], styles['mr-10'])}>集合地點</span>
                <div className={cN(styles['tips'], styles['pc'])}>
                    <span className={cN(styles['icon-wrap'])}>
                        <Info />
                    </span>
                    <span className={cN(styles['text'])}>
                        若出發地與集合地為不同地點，交通方式請參閱產品詳細說明！
                    </span>
                </div>
            </div>
            <div className={cN(styles['border-pc'])}>
                <div className={styles.content}>
                    <ul className={styles.dep}>
                        <li className={styles['sub-title']}>出發地點</li>
                        <li className={styles['contents-list']}>
                            {GroupInfo.StartFromCityList.map((data, idx) => (
                                <span key={idx}>{data.CityName}</span>
                            ))}
                        </li>
                    </ul>
                    <ul className={styles.add}>
                        <li className={styles['sub-title']}>集合地點</li>
                        <li className={styles['contents-list']}>
                            <div className={styles.place}>
                                {StationInfoList.map((data, idx) => (
                                    <span key={idx}>{data.Place}</span>
                                ))}
                            </div>
                        </li>
                    </ul>

                    <div className={cN(styles['tips'], styles['mobile'])}>
                        <span className={cN(styles['icon-wrap'])}>
                            <Info />
                        </span>
                        <span className={cN(styles['text'])}>
                            若出發地與集合地為不同地點，交通方式請參閱產品詳細說明！
                        </span>
                    </div>
                </div>
                <Link
                    className={styles.btns}
                    to="assemble"
                    smooth={true}
                    duration={500}
                    offset={-140}
                >
                    <Flag fill="#222" />
                    集合地點詳情
                </Link>
            </div>
            {/* 光箱 */}
            <LightBox
                className="assemble"
                open={isAssembleOpen}
                ToggleLightBox={() => setIsAssembleOpen(false)}
            >
                {bubbleContent}
            </LightBox>
        </div>
    ) : null;
};

export default Place;
